import { render, staticRenderFns } from "./PcIdxNumWm.vue?vue&type=template&id=d83516de&"
import script from "./PcIdxNumWm.vue?vue&type=script&lang=js&"
export * from "./PcIdxNumWm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports